export const STALE_TITLE = 'Update the booking page first to use your latest changes.'

export type LinkNoun = 'booking' | 'reschedule'

export interface SaveBarNotice {
  variant: 'success' | 'error'
  message: string
  withContactSupport?: boolean
}

export const successNotice = (message: string): SaveBarNotice => ({ variant: 'success', message })

export const errorNotice = (message: string, withContactSupport = true): SaveBarNotice =>
  withContactSupport ? { variant: 'error', message, withContactSupport } : { variant: 'error', message }

export const saveBarNotices = {
  linkCopied: (noun: LinkNoun, linkCount = 1): SaveBarNotice => {
    if (noun === 'reschedule') {
      return successNotice(linkCount > 1 ? 'Reschedule links copied' : 'Reschedule link copied')
    }
    return successNotice(linkCount > 1 ? 'Booking links copied' : 'Booking link copied')
  },
  emailCopied: (): SaveBarNotice => successNotice('Email copied'),
  pushedToDraft: (draftCount: number): SaveBarNotice =>
    successNotice(draftCount > 1 ? 'Invitation emails pushed to draft' : 'Invitation email pushed to draft'),
  partialDrafts: (created: number, total: number): SaveBarNotice => successNotice(`Created ${created} of ${total} drafts — the rest could not be created.`),
  bookingPageUpdated: (): SaveBarNotice => successNotice('Booking page updated'),
  sendEmailsError: (clientCount: number): SaveBarNotice =>
    errorNotice(clientCount > 1 ? 'Something went wrong sending these invitation emails.' : 'Something went wrong sending this invitation email.'),
  sendInviteError: (): SaveBarNotice => errorNotice('Something went wrong sending this invite.'),
  copyLinkError: (noun: LinkNoun): SaveBarNotice => errorNotice(`Something went wrong copying this ${noun} link.`),
  pushToDraftError: (clientCount: number): SaveBarNotice =>
    errorNotice(
      clientCount > 1 ? 'Something went wrong pushing these invitation emails to draft.' : 'Something went wrong pushing this invitation email to draft.',
    ),
  saveBookingError: (): SaveBarNotice => errorNotice('Something went wrong saving this booking.', false),
}
